import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { MdCheckCircle } from 'react-icons/md';
import './CTA.css';

const perks = ['No setup fees', 'Cancel anytime', 'Free 14-day trial'];

export default function CTA() {
  return (
    <section className="cta">
      <div className="cta__glow cta__glow--1" />
      <div className="cta__glow cta__glow--2" />
      <div className="container cta__inner text-center">
        <span className="cta__badge">🚀 Join 500+ Store Owners</span>
        <h2 className="cta__title">
          Ready to grow your store<br />
          <span className="cta__title-highlight">with loyalty rewards?</span>
        </h2>
        <p className="cta__subtitle">
          Join hundreds of store owners already using Pointfinity to retain customers and drive repeat sales.
        </p>
        <div className="cta__perks">
          {perks.map((p) => (
            <span key={p} className="cta__perk">
              <MdCheckCircle /> {p}
            </span>
          ))}
        </div>
        <div className="cta__btns">
          <Link to="/contact" className="cta__btn-main">
            Get Started Today <FiArrowRight />
          </Link>
          <Link to="/download" className="cta__btn-ghost">
            Download App
          </Link>
        </div>
      </div>
    </section>
  );
}
